import { useState } from'react';
import { useSelector } from 'react-redux';
import { RootType } from '@/store';

const usePermission = () => {
    const { menu } = useSelector((state:RootType) => state.user);
    const hasMenuPermission = (menuId:string, operation:string) => {
      return (menu && menu[menuId]) ? menu[menuId]?.[operation] : false;
    };
    return {
        hasMenuPermission,
    };
};

export default usePermission;